import LabeledValue, {LabeledComponentProps} from '@jobseeker/lotus/components/LabeledValue';
import {Box, BoxProps, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';

type Item = any;
interface LabelValueListProps extends BoxProps {
  data: Item[];
  loading: boolean | null;
  getLabel: (entry: Item) => string;
  getValue: (entry: Item) => string | string[];
  labeledValueProps: LabeledComponentProps;
  maxListItemBeforeShowmore?: number;
  placeholderCount?: number;
  showAll?: boolean;
  name?: string;
  emptyState?: React.ReactNode;
}

function LabelValueList(props: LabelValueListProps) {
  const {
    data,
    getLabel,
    getValue,
    maxListItemBeforeShowmore,
    loading,
    placeholderCount,
    name = '',
    emptyState,
  } = props;
  const [showAll, setShowAll] = useState(props.showAll ?? false);
  const maxItems = maxListItemBeforeShowmore ?? 100;
  const list = showAll ? data : (data ?? []).slice(0, maxItems);
  const moreCount = Math.max(0, (data?.length ?? 0) - maxItems);

  return (
    <Box>
      {(list?.length ? list : [...new Array(placeholderCount ?? 4)]).map(
        (item, i) => (
          <LabeledValue
            key={i}
            {...props.labeledValueProps}
            loading={loading as boolean}
            title={item ? getLabel(item) : ''}
            value={item ? getValue(item) : ''}
            emptyState={''}
          />
        )
      )}
      {data?.length > maxItems && (
        <Box sx={{cursor: 'pointer'}} onClick={() => setShowAll(prev => !prev)}>
          <Typography fontSize={12} color={'#49966E'} fontWeight={500}>
            {showAll
              ? 'See less'
              : `+${moreCount} more ${
                  name?.length ? name + (moreCount > 1 ? 's' : '') : ''
                }`}
          </Typography>
        </Box>
      )}
      {!data?.length && loading === false && emptyState}
    </Box>
  );
}

export default LabelValueList;
